import { useEffect, useRef, useState } from "react";
import useAuth from "../../../Redux/useAuth";
import { toast } from "react-toastify";
import copy from "copy-to-clipboard";
import { useUpdateQRCode } from "../../../API/QRCode/UpdateQRCodeGeneration";
import {
    ButtonFinish,
    CodeAuthContainer,
    CodeAuthSecret,
    CodeAuthText,
    ContainerErrors,
    ContainerModel,
    ContainerQRCodeImage,
    ContainerSecretCodeText,
    ContentContainerModel,
    EnteredCode,
    FormTextAuthCode,
    LoadingSecretText,
    QRCodeImage,
    StepsAuthCode,
    StepsAuthScanCode,
    TextMessageCode
} from "./UpdateQRCodeStyles.styled";
import { useUpdateQRCodeValidation } from "../../../API/QRCode/UpdateQRCodeValidation";
import { useLanguageContext } from "../../Languages/Langs/LanguageContext";

interface CloseModel {
    onClose: () => void;
}

export const UpdateQRCode: React.FC<CloseModel> = ({onClose}) => {
    const { tokenAccount, idUser } = useAuth();
    const { t } = useLanguageContext();
    const textRef = useRef<HTMLSpanElement>(null);
    const { qrCode } = useUpdateQRCode(tokenAccount);
    const { updateQRCodeValidation, error, isValid } = useUpdateQRCodeValidation(tokenAccount, idUser || null);

    const copyToClipboard = () => {
          if (!qrCode?.secretCode) return;
    
          const isCopy = copy(qrCode.secretCode);
    
          if (isCopy) {
            toast.success("Copied to Clipboard");
          }
    };

    const [checkQRCode, setCheckQRCode] = useState<string>("");
    
    const filled = !!checkQRCode.trim();
    
    const checkQRCOdeForm = async (evt: React.FormEvent<HTMLFormElement>) => {
      evt.preventDefault();

      await updateQRCodeValidation(checkQRCode);
    
      if (isValid) {
        onClose();
      }
  }
  
    useEffect(() => {
      if (isValid) {
        onClose();
      }
    }, [isValid, onClose]);

    
    return (
        <>
            <ContainerModel>
                    <ContentContainerModel>
                      <ContainerQRCodeImage>
                        {qrCode ? (
                              <>
                                <QRCodeImage src={qrCode.qrCode} alt="QR Code" />
                                <StepsAuthScanCode>{t("privateTraslate.Models.UpdateQRCodeStepTitle")}</StepsAuthScanCode>
                              </>
                        ) : (
                            // replace on animation
                              <p>Loading QR code...</p>
                        )}
                      </ContainerQRCodeImage>
                          
                      <ContainerSecretCodeText>
                        {qrCode ? (
                            <>
                                <CodeAuthContainer>
                                  <CodeAuthText>Secret</CodeAuthText>
                                  <CodeAuthSecret
                                    ref={textRef}
                                    onClick={copyToClipboard}>
                                    {qrCode.secretCode}
                                  </CodeAuthSecret>
                                </CodeAuthContainer>
                                  <StepsAuthCode>{t("privateTraslate.Models.UpdateQRCodeStepsText")}</StepsAuthCode>
                            </>
                        ) : (
                            // add animation
                            <LoadingSecretText>Loading secret</LoadingSecretText>
                        )}
                      </ContainerSecretCodeText>
                      
                          <TextMessageCode>{t("privateTraslate.Models.UpdateQRCodeRecommendationText")}</TextMessageCode>
                          <FormTextAuthCode onSubmit={checkQRCOdeForm}>
                              <EnteredCode
                                type="text"
                                placeholder={t("privateTraslate.Models.UpdateQRCodeValidationCode")}
                                value={checkQRCode ?? ""}
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCheckQRCode(e.target.value)}
                              />
                            <ContainerErrors>
                              {error && <p style={{ color: "red" }}>{error}</p>}
                              {isValid && <p style={{ color: "green" }}>✅ {t("privateTraslate.Models.UpdateQRCodeValidCode")}</p>}
                            </ContainerErrors>
                        <ButtonFinish
                            type="submit"
                            value={t("privateTraslate.Models.UpdateQRCodeButtonFinish")}
                            $filled={filled}
                            disabled={!filled}
                        />
                          </FormTextAuthCode>
                    </ContentContainerModel>
                    
                  </ContainerModel>
        </>
    )
}